import { Box, styled } from "@mui/material";

export const ToolbarOuterBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.core.grey._20,
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
}));

export const FilterPanelCard = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.core.white,
    boxShadow: theme.shadow.boxShadow.sm,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
}));

export const GroupHeaderBox = styled(Box)(({ theme }) => ({
    background: theme.palette.core.white,
    position: "sticky",
    padding: theme.spacing(2, 3),
    opacity: 1,
    zIndex: 1,
    top: "-10px",
}));

export const GroupItems = styled("ul")(({ theme }) => ({
    padding: `0 0 0 ${theme.spacing(1)}`,
}));
